import React from 'react';
import { TeachingCardComponent } from '../teaching-card-component/teaching-card-component';
import "./styles.css";
import { teaching } from './teaching';

export const TeachingComponentV2 = () => (
	<React.Fragment>
        <div class="teachingeouter">
            <div class="title">
                <div class="teachingSubTitle">
                    Teaching Experiences
                </div>
                <div class="teachingSubContent">
                    Teaching had helped me convey my knowledge and concepts more clearly. It had been a rewarding experience helping my juniors in assisting their education and paths.
                </div>
            </div>
            <div class="teachingMain">
                {
                    teaching.map((t)=>{
                        return(
                            <TeachingCardComponent course={t.course} job={t.job}/>
                        )
                    })
                }
            </div>
        </div>
	</React.Fragment>
);